const GONE_PATH = "/410/"

/** WordPress search URLs (?s=) — client fallback for local dev (Cloudflare uses functions/_middleware.js). */
export const redirectLegacyWordPressSearch = (): boolean  => {
  if (typeof window === "undefined") {
    return false
  }

  if (!new URLSearchParams(window.location.search).has("s")) {
    return false
  }

  window.location.replace(GONE_PATH)
  return true
}
